interface EntityMap {
  [key: string]: string;
}

const entities: EntityMap = {
  'amp': '&',
  'lt': '<',
  'gt': '>',
  'quot': '"',
  'apos': "'",
  'nbsp': ' ',
};

export default function decodeHTMLEntities(text?: string): string {

  if (!text) return "";

  const result = text.replace(/&(#?[xX]?[\da-fA-F]+|\w+);/g, (match: string, entity: string): string => {
    // Обработка цифровых сущностей (&#123; и &#x1F600;)
    if (entity.startsWith('#')) {
      const isHex = entity[1].toLowerCase() === 'x';
      const codeStr = isHex ? entity.slice(2) : entity.slice(1);
      const radix = isHex ? 16 : 10;
      const code = parseInt(codeStr, radix);

      if (!isNaN(code)) {
        // Проверка на валидность кода символа
        return code >= 0 && code <= 0x10FFFF
          ? String.fromCodePoint(code)
          : match;
      }
      return match;
    }
    // Обработка именованных сущностей
    return entities[entity] || match;
  });
  return result || "";
}